import { render, staticRenderFns } from "./UserGridView.vue?vue&type=template&id=89040500&"
import script from "./UserGridView.vue?vue&type=script&lang=js&"
export * from "./UserGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports